import { RootState } from 'app/store';

export const selectResume = (state: RootState) => state.resume.resume;
export const selectIsLoadingResume = (state: RootState) =>
  state.resume.isLoadingResume;
